import { Link, useNavigate, getRouteApi } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { ContactList } from '@/components/finance';
import { OrganizationTypeConflictCount } from './OrganizationTypeConflictCount';

export function ContactsDirectory() {
  const navigate = useNavigate();
  // Look the route up by path at runtime (same idiom as CompleteRegistration /
  // ResetPassword) rather than importing the route module — importing the route
  // module here would drag its top-level createFileRoute call into every barrel
  // consumer. Resolved inside the component (not at module load) so merely
  // importing this file from the barrel never runs getRouteApi.
  const { returnTo, reportId } = getRouteApi('/admin/finance/contacts/').useSearch();
  const showBackToReport = returnTo === 'report' && !!reportId;

  return (
    <div className="p-6 space-y-4">
      {showBackToReport && (
        <Link
          to="/admin/finance/reports/$reportId"
          params={{ reportId: reportId! }}
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to report
        </Link>
      )}
      <OrganizationTypeConflictCount
        onReview={(contactId) =>
          navigate({ to: '/admin/finance/contacts/$contactId', params: { contactId } })
        }
      />
      <ContactList
        onSelectContact={(contactId) =>
          navigate({ to: '/admin/finance/contacts/$contactId', params: { contactId } })
        }
        onGoToInbox={() => navigate({ to: '/admin/finance' })}
      />
    </div>
  );
}
